import {
	configure,
	index,
	stats,
	infiniteHits,
} from 'instantsearch.js/es/widgets';
import instantsearch from 'instantsearch.js/es';
import { getProductDataFromWooCommerce } from './product-helpers/fill-wc-data';
import { analyticsWidget } from '../analytics';

const productsSeen = {
	previously: [],
	now: [],
	again: [],
};

const fillTemplate = function ( templateString, templateVars ) {
	const func = new Function(
		...Object.keys( templateVars ),
		'return `' + templateString + '`;'
	);
	return func( ...Object.values( templateVars ) );
};

/**
 * The very special search widget for products
 * This has some xxxxtra features compared to regular post type search.
 * jQuery ajax is used to fetch product data from WooCommerce on demand.
 */
const productSearch = {
	searcher: ( search, postType ) => {
		const is_main = search.indexName === postType.ais_index;

		const _index = is_main
			? search.mainIndex
			: index( { indexName: postType.ais_index } );

		_index.addWidgets( [
			configure( {
				hitsPerPage: postType.per_page,
				filters: MWC_AIS.product_filters,
			} ),

			infiniteHits( {
				container: `.ma-${ postType.type }-search-result`,
				templates: {
					item: ( hit, bindEvent ) => {
						if ( hit ) {
							return fillTemplate( postType.item_template, {
								item: hit,
								bindEvent,
								instantsearch,
							} );
						}
					},

					empty: '',
					showMoreText: postType.show_more_text,
				},

				/**
				 * Documentation does not really say that you can use transformItems like this.
				 * But this contains everyting needed to do the ajax fetch WooCommerce data.
				 * So it's niiice. 🤷🏿‍♂️
				 *
				 * @param {Object} hitItems
				 */
				transformItems( hitItems ) {
					if (
						MWC_AIS.show_prices === 'yes' ||
						MWC_AIS.show_stock_status === 'yes' ||
						MWC_AIS.show_buy === 'yes'
					) {
						modifyHitsWithData( hitItems );
					}
					return hitItems;
				},

				cssClasses: {
					list: [
						MWC_AIS.show_prices === 'yes' ? 'ma-prices-show' : '',
						MWC_AIS.show_stock_status === 'yes'
							? 'ma-stock-show'
							: '',
						MWC_AIS.show_buy === 'yes' ? 'ma-buy-show' : '',
					],
				},
			} ),

			stats( {
				container: `.ma-${ postType.type }-search-header`,
				templates: {
					text: `<header><h2>${ postType.search_result_title }</h2></header>`,
				},
			} ),
		] );

		is_main || search.addWidgets( [ _index ] );
	},
};

/**
 * Fill more product data from WooCommerce
 *
 * @param {Object} hitItems
 */
const modifyHitsWithData = ( hitItems ) => {
	productsSeen.now = [];
	productsSeen.again = [];

	console.log( hitItems );

	/**
	 * Filter out a list of products that is seen for the first time
	 */
	const firstTimeSeen = hitItems.filter( ( searchHit ) => {
		return ! productsSeen.previously.some( ( previousHit ) => {
			return searchHit.product_id === previousHit.product_id;
		} );
	} );

	/**
	 * Filter out products that has been seen before (these products have already looked up data via ajax)
	 */
	const seenBefore = hitItems.filter( ( searchHit ) => {
		return productsSeen.previously.some( ( previousHit ) => {
			return searchHit.product_id === previousHit.product_id;
		} );
	} );

	productsSeen.now = firstTimeSeen;
	productsSeen.again = seenBefore;

	if ( productsSeen.now.length || productsSeen.again.length ) {
		productsSeen.previously.push( ...productsSeen.now );
		getProductDataFromWooCommerce( productsSeen.now, productsSeen.again );
	}
};

export default productSearch;
